export const SET_MESSAGE = 'SET_MESSAGE';

export default {
    SET_MESSAGE
}